import React, { useMemo } from 'react';

import { RegulationsPanelForm } from '../../../../Regulations/Components/RegulationsPanelForm';

import { HasAccessTo } from 'app/components/Authorization';
import { EMPLOYER } from '../../../../../common/Authorization/entities';
import { EDIT } from '../../../../../common/Authorization/permissions';
import { useEmployerDetailContext } from '../EmployerDetailContext';

export const EmployerSummaryTab = () => {
  const { employerDetail: employer, isLoading: loading } = useEmployerDetailContext();

  const products = useMemo(() => {
    if (loading || !employer) {
      return [];
    }

    const productsMap = (employer?.connections || []).reduce((map: Record<string, any>, connection) => {
      if (connection.product) {
        map[connection.connectionId] = {
          ...connection.product,
          connectionId: connection.connectionId,
          connectionName: connection.connectionName,
          productTypes: [],
          productIds: [],
          relatedProductIds: [],
        };
      }
      return map;
    }, {});
    return Object.keys(productsMap).map(k => productsMap[k]);
  }, [employer, loading]);

  const disabledIfNoAccessToEdit = HasAccessTo(EMPLOYER, EDIT);

  return (
    <RegulationsPanelForm
      ownerId={employer?.owner?.ownerId ?? ''}
      employerId={employer?.employerId ?? ''}
      products={products}
      productsLoading={loading}
      editable={disabledIfNoAccessToEdit}
      withRegulationsEmployerScales
    />
  );
};
